import React from 'react';
import parse from 'html-react-parser';

import ShareButton from './ShareButton';

import { Heading } from '@/components/design/heading';
import useUserActions from '@/hooks/queries/useUserActions';
import useTranslation from '@/hooks/useTranslation';
import TextIcon from '@/svgs/text.svg';

type Props = {
  caption: string;
  hashtags: string;
  content_id: string;
};
const ContentText: React.FC<Props> = ({ caption, hashtags, content_id }) => {
  const { t } = useTranslation('pages.content');

  const { mutateAsync: logUserAction } = useUserActions({
    model_id: content_id,
    model_type: 'content_bank',
  });

  return (
    <div className="flex flex-col gap-4">
      <Heading title={t('text')} icon={<TextIcon />} />
      <div className="p-[14px] border-border border-[1px] rounded-[12px] flex flex-col gap-[10px]">
        <div className="flex gap-3">
          <ShareButton
            title={t('copyCaption')}
            content={caption}
            onShare={() =>
              void logUserAction({ action: 'copy_caption_action' })
            }
          />
          <ShareButton
            title={t('copyHashtag')}
            content={hashtags}
            onShare={() =>
              void logUserAction({ action: 'copy_hashtag_action' })
            }
          />
        </div>
        {caption && (
          <p className="text-tiny font-normal wrap-anywhere">
            {parse(caption)}
          </p>
        )}
        {hashtags && (
          <p className="text-tiny font-normal wrap-anywhere">
            {parse(hashtags)}
          </p>
        )}
      </div>
    </div>
  );
};

export default ContentText;
